import { FC, useEffect } from 'react';
import useModals from '@components/modals/hooks/useModals';
import { createStorageKey, local } from '@utils/storage';
import { StorageKeys } from '@constants/storageKeys';
import { ModalType } from '@models/modals/Modals';
import { Sizes } from '@utils/sizes';
import useFetchCurrentUser from '@components/features/currentUser/hooks/useFetchCurrentUser';

const Sam: FC = () => {
    const { data: user } = useFetchCurrentUser();
    const hideSamIntroductionModal = local.getItem(createStorageKey([StorageKeys.HideSamIntroductionModal])) === 'true';
    const { openModal, getModalByType } = useModals();

    useEffect(() => {
        if (hideSamIntroductionModal || getModalByType(ModalType.SamIntroduction)) {
            return;
        }

        if (user?.samTenantLevel && user.samTenantLevel >= 1 && user?.userType === 2) {
            openModal({
                type: ModalType.SamIntroduction,
                size: Sizes.lg,
                className: 'samIntroductionModal',
                modalData: {},
            });
        }
    }, [hideSamIntroductionModal, user]);

    return <div className="sam__messages" />;
};

export default Sam;
